import React from "react";
import { Form, Input, Button, DatePicker, Select, message } from "antd";
import "./SignUp.less";
import { ROUTE_LOGIN } from "../../../constant/routes";
import { useGenerateUserMutation } from "../../../redux/services/auth";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setUserId, setAccessToken } from "../../../redux/features/authSlice";
import dayjs from "dayjs";

const { Option } = Select;

const indianCities = [
  { value: "andhra_pradesh", label: "Andhra Pradesh" },
  { value: "arunachal_pradesh", label: "Arunachal Pradesh" },
  { value: "assam", label: "Assam" },
  { value: "bihar", label: "Bihar" },
  { value: "chhattisgarh", label: "Chhattisgarh" },
  { value: "goa", label: "Goa" },
  { value: "gujarat", label: "Gujarat" },
  { value: "haryana", label: "Haryana" },
  { value: "himachal_pradesh", label: "Himachal Pradesh" },
  { value: "jammu_and_kashmir", label: "Jammu and Kashmir" },
  { value: "jharkhand", label: "Jharkhand" },
  { value: "karnataka", label: "Karnataka" },
  { value: "kerala", label: "Kerala" },
  { value: "ladakh", label: "Ladakh" },
  { value: "madhya_pradesh", label: "Madhya Pradesh" },
  { value: "maharashtra", label: "Maharashtra" },
  { value: "manipur", label: "Manipur" },
  { value: "meghalaya", label: "Meghalaya" },
  { value: "mizoram", label: "Mizoram" },
  { value: "nagaland", label: "Nagaland" },
  { value: "odisha", label: "Odisha" },
  { value: "punjab", label: "Punjab" },
  { value: "rajasthan", label: "Rajasthan" },
  { value: "sikkim", label: "Sikkim" },
  { value: "tamil_nadu", label: "Tamil Nadu" },
  { value: "telangana", label: "Telangana" },
  { value: "tripura", label: "Tripura" },
  { value: "uttar_pradesh", label: "Uttar Pradesh" },
  { value: "uttarakhand", label: "Uttarakhand" },
  { value: "west_bengal", label: "West Bengal" },
  { value: "chandigarh", label: "Chandigarh" },
  { value: "delhi", label: "Delhi" },
  { value: "puducherry", label: "Puducherry" },
  { value: "ladakh", label: "Ladakh" },
];

const Signup = () => {
  const [generateUser] = useGenerateUserMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const phonenumber = useSelector((state) => state.auth.mobileNumber);
  const calculateAge = (birthDate) => {
    if (!birthDate) return null;
    console.log(dayjs().diff(birthDate, "year"));
    return dayjs().diff(birthDate, "year");
  };

  const handleFinish = async (values) => {
    const age = calculateAge(values.dob);
    if (!age || age < 10 || age > 50) {
      message.error("Please select a valid date of birth!");
      return;
    }
    const payload = {
      name: values.name,
      email: values.email,
      country_code: "+91",
      mobile_number: values.phone,
      city: values.city,
      age: age,
      // profile_image: "",
      status: "",
    };

    try {
      const response = await generateUser(payload);

      if (response.data?.message === "User Created Successfully.") {
        const userData = response.data.data;
        message.success("User created successfully!");
        dispatch(setUserId(userData.user_id));
        dispatch(setAccessToken(userData.access_token));
        navigate(ROUTE_LOGIN);
      }

      if (response.error?.data?.detail === "Mobile Number already registered") {
        message.error(
          "User already exists. Please login or try another number."
        );
      }
    } catch (error) {
      message.error(error.message || "Signup failed. Please try again.");
    }
  };

  return (
    <div className='signup-container'>
      <div className='signup-box'>
        <h2>Create a new account</h2>
        <Form
          name='signup'
          layout='vertical '
          onFinish={handleFinish}
          initialValues={{
            phone: phonenumber || undefined,
          }}
        >
          <Form.Item
            label='Name'
            name='name'
            rules={[{ required: true, message: "Please enter your name!" }]}
          >
            <Input placeholder='Enter Name' />
          </Form.Item>
          <Form.Item
            label='Email'
            name='email'
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email address!" },
            ]}
          >
            <Input placeholder='Enter Email' />
          </Form.Item>

          <Form.Item
            label='Phone Number'
            name='phone'
            rules={[
              { required: true, message: "Please enter your phone number!" },
              {
                pattern: /^[0-9]{10}$/,
                message: "Enter a valid 10-digit number!",
              },
            ]}
          >
            <Input
              placeholder='Enter Phone Number'
              defaultValue={phonenumber}
              disabled={!!phonenumber}
            />
          </Form.Item>

          <Form.Item
            label='Date of Birth'
            name='dob'
            rules={[{ required: true, message: "Please select your age!" }]}
          >
            <DatePicker
              format='YYYY-MM-DD'
              style={{ width: "100%" }}
              placeholder='Select Date of Birth'
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </Form.Item>

          <Form.Item
            label='States'
            name='city'
            rules={[{ required: true, message: "Please select your state!" }]}
          >
            <Select placeholder='Select State' options={indianCities} />
          </Form.Item>

          <Form.Item>
            <Button
              type='primary'
              htmlType='submit'
              className='continue-button'
            >
              Continue
            </Button>
          </Form.Item>
          <Form.Item>
            <Link to={ROUTE_LOGIN}>
              <Button
                type='default'
                block
                htmlType='submit'
                className='back-button'
              >
                Back
              </Button>
            </Link>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Signup;
